enum DispatcherEvent {
  AddFavorite = 'add_favorite',
  AddSavedSearch = 'add_saved_search',
  CloseFavorites = 'close_favorites',
  ContinuePurchase = 'continue_purchase',
  EnterFullscreen = 'enter_fullscreen',
  FavoriteAdded = 'favorite_added',
  FavoriteRemoved = 'favorite_removed',
  LeaveFullscreen = 'leave_fullscreen',
  Link = 'link',
  LogIn = 'log_in',
  OpenModal = 'open_modal',
  PageReady = 'page_ready',
  SavedSearchDeleted = 'saved_search_deleted',
  SavedSearchSaved = 'saved_search_saved',
  SearchVehicles = 'search_vehicles',
  SebastianPrompt = 'sebastian_prompt',
  Share = 'share',
  StartPreOrder = 'start_preorder',
  StartPurchase = 'start_purchase',
  ToggleTradeIn = 'toggle_trade_in',
  UpdateGeolocation = 'update_geolocation'
}

export default DispatcherEvent;
